import { Option } from '../../lib/types/models/options/option'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getOption(id: number) {
  return restApiClient.url(constructApiUrl(API.options.get.url, { id })).get<Option>()
}
